import html2canvas from "html2canvas";

const crearColumna = (texto) => {
    const td = document.createElement("td");
    td.textContent = texto;
    return td;
};

export const crearFilaConvencion = (turno) => {
    const tr = document.createElement("tr");
    tr.style.backgroundColor = turno.color;

    const columnas = [
        turno.sigla,
        turno.horas,
        `${turno.inicio} - ${turno.fin}`,
        `${turno.inicio_receso} - ${turno.fin_receso}`,
        turno.nombre,
    ];

    columnas.forEach((columna) => {
        const td = crearColumna(columna);
        tr.appendChild(td);
    });

    return tr;
};

export const crearImagenDesdeElemento = async (elemento, nombreImagen) => {
    const canvas = await html2canvas(elemento, {
        scale: 3,
    });

    const anchorTag = document.createElement("a");
    document.body.appendChild(anchorTag);
    anchorTag.download = nombreImagen;
    anchorTag.href = canvas.toDataURL();
    anchorTag.target = "_blank";
    anchorTag.click();
};

export const exportarCuadroConvenciones = async (turnos) => {
    const tabla = document.getElementById("tablaConvenciones");
    const cuerpoTabla = document.getElementById("bodyTablaConvenciones");

    turnos.forEach((turno) => {
        const tr = crearFilaConvencion(turno);
        cuerpoTabla.appendChild(tr);
    });

    tabla.style.display = "";
    await crearImagenDesdeElemento(tabla, "convenciones-turnos.jpg");
    tabla.style.display = "none";
    cuerpoTabla.innerHTML = "";
};
